// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GhostButton: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fillRule="evenodd" d="M30 15c0-8.2-6.8-15-15-15S0 6.8 0 15s6.8 15 15 15 15-6.8 15-15zM8.6 13.2h4.6V8.6c0-.6.4-1 1-1h1.7c.6 0 1 .4 1 1v4.6h4.6c.6 0 1 .4 1 1v1.7c0 .6-.4 1-1 1h-4.6v4.6c0 .6-.4 1-1 1h-1.7c-.6 0-1-.4-1-1v-4.6H8.6c-.6 0-1-.4-1-1v-1.7c0-.6.4-1 1-1z" clipRule="evenodd"/></svg>;
};

export default React.memo(GhostButton);
